/**
 * Generate an array of years to present
 *
 * @return {Array}
 */
const generateYears = () => {
    let yearArray = [];
    const now = new Date().getFullYear();
    for (let i = 2012; i <= now; i++) {
        yearArray.push({id: i, name: i.toString()});
    }
    return yearArray;
};

export const YEARS = generateYears();

export const MONTHS = [
    {id: '01', name: 'January'},
    {id: '02', name: 'February'},
    {id: '03', name: 'March'},
    {id: '04', name: 'April'},
    {id: '05', name: 'May'},
    {id: '06', name: 'June'},
    {id: '07', name: 'July'},
    {id: '08', name: 'August'},
    {id: '09', name: 'September'},
    {id: '10', name: 'October'},
    {id: '11', name: 'November'},
    {id: '12', name: 'December'},
];

export const MONTH_NAMES = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December'
];

export const HOURS = [
    {id: '00', name: '12'},
    {id: '01', name: '1'},
    {id: '02', name: '2'},
    {id: '03', name: '3'},
    {id: '04', name: '4'},
    {id: '05', name: '5'},
    {id: '06', name: '6'},
    {id: '07', name: '7'},
    {id: '08', name: '8'},
    {id: '09', name: '9'},
    {id: '10', name: '10'},
    {id: '11', name: '11'},
];

/**
 * Generate an array of minutes in an hour
 *
 * @return {Array}
 */
const generateMinutes = () => {
    let minArray = [];
    for (let i = 0; i < 60; i++) {
        let minVal = String('00' + i).slice(-2);
        let minObj = {id: minVal, name: minVal};
        minArray.push(minObj);
    }
    return minArray;
};

export const MINUTES = generateMinutes();

export const MINUTES_QUARTER = [
    {id: '00', name: '00'},
    {id: '15', name: '15'},
    {id: '30', name: '30'},
    {id: '45', name: '45'},
    {id: '59', name: '59'},
];

export const AMPM = [
    {id: 'am', name: 'AM'},
    {id: 'pm', name: 'PM'},
];

export const TIME_ZONES = [
    {id: 'Pacific/Honolulu', name: 'Hawaii-Aleutian Time'},
    {id: 'America/Anchorage', name: 'Alaska Time'},
    {id: 'America/Los_Angeles', name: 'Pacific Time'},
    {id: 'America/Denver', name: 'Mountain Time'},
    {id: 'America/Chicago', name: 'Central Time'},
    {id: 'America/New_York', name: 'Eastern Time'},
];

export const TIME_ZONE_OFFSETS = [
    {id: '-10:00', name: 'UTC-10:00'},
    {id: '-09:00', name: 'UTC-09:00'},
    {id: '-08:00', name: 'UTC-08:00'},
    {id: '-07:00', name: 'UTC-07:00'},
    {id: '-06:00', name: 'UTC-06:00'},
    {id: '-05:00', name: 'UTC-05:00'},
    {id: '-04:00', name: 'UTC-04:00'},
];



// WEBPACK FOOTER //
// ./src/Fuse/shared/dateTimeLists.js